import { useEffect } from "react";

import { useParams } from "react-router-dom";

export default function ExternalRedirect({ template }) {

    const params = useParams();

    useEffect(() => {

        let url = template;

        Object.entries(params).forEach(([key, value]) => {

            url = url.replace(`:${key}`, encodeURIComponent(value));

        });

        window.location.replace(url);

    }, [template, params]);

    return null;

}